import { ActionButton, DefaultForm, Modal, ModalButtonBar, ModalProps } from '@lessonup/typescript-core/ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { useAppServices } from '../../appServices/AppServicesContext';

const TRANSLATION_NAMESPACE = 'forgotPasswordModal';

function ForgotPasswordModal(props: ModalProps<undefined>) {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  const services = useAppServices();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  function handleClose() {
    return props.closeModal(undefined);
  }

  function modalContent() {
    return formSubmitted ? <ConfirmMessage text={t('thank-you')} closeModal={handleClose} /> : <ForgotPasswordForm />;
  }

  return (
    <Modal title={t('title')} isOpen onRequestClose={handleClose} width="medium">
      {modalContent()}
    </Modal>
  );
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-unused-vars -- auto-generated TECH-258
function ForgotPasswordForm(props: {}) {
  const { t } = useTranslation();

  return (
    <div className="forgot-password-content">
      <div className="login__page login__page-options">
        <div className="login__page-option">
          <DefaultForm>
            <h3>{'Stel een nieuw wachtwoord in'}</h3>
            <input type="text" placeholder="Email" />
            <ActionButton theme="light">{t('Verstuur')}</ActionButton>
          </DefaultForm>
        </div>
        <div className="login__page-divider" />
        <div className="login__page-option">
          <DefaultForm>
            <h3>{'Stuur mij een magische link'}</h3>
            <input type="text" placeholder="Email" />
            <ActionButton theme="light">{t('Verstuur')}</ActionButton>
          </DefaultForm>
        </div>
      </div>
    </div>
  );
}

const ConfirmMessage: React.FunctionComponent<{ text: string; closeModal: (res: undefined) => void }> = (props) => {
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  function clickHandler(e: React.MouseEvent | React.TouchEvent) {
    props.closeModal(undefined);
  }

  return (
    <div>
      <div className="flagmodal__header">
        <div className="flagmodal_headertext">{props.text}</div>
      </div>
      <ModalButtonBar layout="center">
        <ActionButton theme="light" onClick={clickHandler}>
          {t('ok')}
        </ActionButton>
      </ModalButtonBar>
    </div>
  );
};

export default ForgotPasswordModal;
